import * as types from '../mutation-types'
import Cookie from 'js-cookie'

const state = {
    device: {
        isMobile: false,
        isTablet: false
    },
    sidebar: {
        opened: false,
        hidden: false
    },
    effect: {
        translate3d: true
    },
    token: '',
    user: {
        id: '',
        name: ''
    },
    isAuditDetail: true
}

const mutations = {
    [types.TOGGLE_DEVICE](state, device) {
        state.device.isMobile = device === 'mobile'
        state.device.isTablet = device === 'tablet'
    },
    [types.TOGGLE_SIDEBAR](state, opened) {
        if (state.device.isMobile) {
            state.sidebar.opened = opened
        } else {
            state.sidebar.opened = true
        }
    },
    [types.SWITCH_EFFECT](state, effectItem) {
        for (let name in effectItem) {
            state.effect[name] = effectItem[name]
        }
    },
    [types.SET_TOKEN](state, token) {
        Cookie.set('token', token)
        state.token = token
    },
    [types.LOGIN_USER](state, user) {
        state.user = user
    },
    [types.IS_AUDIT_DETAIL](state, value) {
        state.isAuditDetail = value
        sessionStorage.setItem('isAuditDetail', value)
    }
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js